import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { GCP } from "@graylog/enterprise-api";
import formValidation from "./utils/formValidation";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import handleFileUpload from "../helpers/fileReader";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const [regions, setRegions] = useState([]);
  useEffect(() => {
    GCP.getGCPRegions().then((response) => {
      const respRegions = Object.keys(response).map((key) => ({ label: response[key] }));
      setRegions(respRegions);
    });
  }, []);
  const { formData } = useContext(FormDataContext);
  const isFormValid = formValidation.isFormValid(["gcpName", "projectId", "clientId", "serviceAccountKey"], formData);
  const onFileUpload = (e) => {
    e.persist();
    handleFileUpload(e.target.files[0], (fileName, fileContent) => onChange(e, { fileName, fileContent }));
  };
  const accountKeyHelpText = formData.serviceAccountKey && formData.serviceAccountKey.fileName ? t("gcp.fields.service_account_key_current_file", { fileName: formData.serviceAccountKey.fileName }) : t("gcp.fields.service_account_key_help");
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit,
      buttonContent: t("gcp.buttons.verify_and_proceed"),
      disabled: isFormValid,
      title: "",
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "gcpName",
        type: "text",
        fieldData: formData.gcpName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "projectId",
        type: "text",
        fieldData: formData.projectId,
        onChange,
        label: t("gcp.fields.project_id"),
        help: t("gcp.fields.project_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        help: t("gcp.fields.client_id_help"),
        label: t("gcp.fields.client_id"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "serviceAccountKey",
        type: "file",
        onChange: onFileUpload,
        fieldData: formData.serviceAccountKey,
        label: t("gcp.fields.service_account_key"),
        help: accountKeyHelpText,
        accept: ".json",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "gcpRegion",
        onChange,
        fieldData: formData.gcpRegion,
        help: t("gcp.fields.bigquery_region_help"),
        label: t("gcp.fields.bigquery_region")
      },
      renderOptions(regions, t("gcp.fields.select_region"), false)
    )
  );
};
export default StepAuthorize;
